import { render, staticRenderFns } from "./CategoryAlertsTable.vue?vue&type=template&id=5e583d0a"
import script from "./CategoryAlertsTable.vue?vue&type=script&lang=ts"
export * from "./CategoryAlertsTable.vue?vue&type=script&lang=ts"
import style0 from "./CategoryAlertsTable.vue?vue&type=style&index=0&id=5e583d0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports